import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Site from "@/components/site/Site";
import OwnerPage from "@/components/owner/OwnerPage";
import PaymentResult from "@/pages/PaymentResult";
import VipPage from "@/components/vip/VipPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/owner" element={<OwnerPage />} />
        <Route path="/payment/success" element={<PaymentResult />} />
        <Route path="/payment/cancel" element={<PaymentResult />} />
        <Route path="/vip" element={<VipPage />} />
        <Route path="/:page?" element={<Site />} />
      </Routes>
      <Toaster position="top-center" richColors theme="dark" />
    </BrowserRouter>
  );
}

export default App;
